import React, { useCallback, useEffect } from "react";

// components
// import ServiceCard from "../misc/ServiceCard";
import Paginate from "../../../components/ui/paginate";

// state and service
import { get_services } from "../../../service/api/service";
import { onBack, onNext } from "../../../store/slices/service";
import { setTitle } from "../../../store/slices/navbar";
import ServiceCard from "../misc/ServiceCard";
import { useAppDispatch, useAppSelector } from "../../../store";
import { Loader } from "../../../components/animation/Loader";

const ServiceDashboard = () => {
  const dispatch = useAppDispatch();
  const current_page = useAppSelector(({ service }) => service.current_page);
  const last_page = useAppSelector(({ service }) => service.last_page);
  const services = useAppSelector(({ service }) => service.services);
  const loading = useAppSelector(({ service }) => service.loading);

  const onLoad = useCallback(() => {
    dispatch(setTitle("Services"));
    get_services(dispatch, current_page);
  }, [current_page, dispatch]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  if (loading) {
    return <Loader />;
  }

  return (
    <main className="w-full">
      <div className="pb-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {services.map((item) => (
            <ServiceCard key={item.id} item={item} />
          ))}
        </div>
      </div>

      <Paginate
        current_page={current_page}
        last_page={last_page}
        onBack={() => dispatch(onBack())}
        onNext={() => dispatch(onNext())}
      />
    </main>
  );
};

export default ServiceDashboard;
